<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.Header({
              text: 'Kafelki'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['title_pl']),
                fields: [
                  new fields.Input({
                    label: 'Imię i nazwisko',
                    type: 'textarea',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'title'],
                    multilingual: true
                  }),
                  new fields.Input({
                    label: 'Stanowisko',
                    modelPath: [this, 'form', 'items', i, 'subtitle'],
                    multilingual: true
                  }),
                  new fields.Input({
                    label: 'Numer telefonu',
                    modelPath: [this, 'form', 'items', i, 'telephone']
                  }),
                  new fields.Input({
                    label: 'Adres email',
                    modelPath: [this, 'form', 'items', i, 'email']
                  }),
                  new fields.Image({
                    label: 'Zdjęcie',
                    modelPath: [this, 'form', 'items', i, 'image']
                  }),
                  new fields.Input({
                    label: 'Link do filmu YT',
                    modelPath: [this, 'form', 'items', i, 'video_url']
                  }),
                  new fields.Link({
                    label: 'Odnośnik',
                    modelPath: [this, 'form', 'items', i, 'link'],
                    hideLinkLabel: true
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
